import '@assets/css/font.css';
import '@assets/css/common.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React from 'react';
import Head from 'next/head';
import {SWRConfig} from 'swr';
import {RecoilRoot} from 'recoil';
import {apiGet} from '@src/api';
import * as Sentry from '@sentry/react';
import AppMain from '@src/components/AppMain';
import {getWindow, isProd} from '@src/utils/common';
import {version} from '../package.json';
import 'intersection-observer';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_MATRIX_URL,
    release: version,
  });
}

const window = getWindow();
if (window.Kakao) {
  window.Kakao.init(process.env.NEXT_PUBLIC_KAKAO_SDK_JAVASCRIPT_KEY);
}

if (window.TiaraTracker) {
  const config = {
    svcDomain: 'm.ss.kakao.com',
    deployment: `${isProd() ? 'production' : 'dev'}`, // 개발서버인 경우 "dev"로 세팅
    autoClick: true, // 마크업에 기록된 클릭이벤트 자동 전송
  };

  window.TiaraTracker.getInstance().init(config);
}

function App (props: any) {
  return (
    <Sentry.ErrorBoundary>
      <SWRConfig
        value={{
          fetcher: apiGet,
          revalidateOnMount: true,
          revalidateOnFocus: false,
          revalidateOnReconnect: false,
          shouldRetryOnError: false,
          loadingTimeout: 10000,
        }}
      >
        <RecoilRoot>
          <Head>
            <title>구독ON</title>
            <meta
              name="viewport"
              content="user-scalable=no, width=device-width, height=device-height, initial-scale=1, maximum-scale=1, minimum-scale=1.0, viewport-fit=cover"
            />
          </Head>
          <AppMain {...props} />
        </RecoilRoot>
      </SWRConfig>
    </Sentry.ErrorBoundary>
  );
}

export default App;
